import React from 'react';
import { Helmet } from 'react-helmet-async';
import CaseStudies from '../components/CaseStudies';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://wayug.com/' },
    { '@type': 'ListItem', position: 2, name: 'Case Studies', item: 'https://wayug.com/case-studies' },
  ],
};

export default function CaseStudiesPage() {
  return (
    <div className="page-content subpage-content">
      <Helmet>
        <title>Enterprise IT Case Studies &amp; Success Stories | Wayug Infotech</title>
        <meta
          name="description"
          content="Discover how Wayug Infotech delivered 70% cloud cost reduction, custom steel ERP automation, and Mediway hospital software deployments across India."
        />
        <link rel="canonical" href="https://wayug.com/case-studies" />
        <meta property="og:title" content="Enterprise IT Case Studies &amp; Success Stories | Wayug Infotech" />
        <meta
          property="og:description"
          content="Real results from enterprise cloud migrations, manufacturing ERP implementations, and hospital management software deployments."
        />
        <meta property="og:url" content="https://wayug.com/case-studies" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      </Helmet>
      <CaseStudies />
    </div>
  );
}
